// Zone → sourced music track. Swapping a zone's music is a one-line change
// here plus the file in public/audio/music/ and its entry in CREDITS.md.
//
// Current picks (Phase 8, quirky-lounge direction): PENDING USER AUDITION —
// the files below are the recommended defaults and may not exist locally
// yet; engine/music.ts warns and plays nothing for missing files.
//
// Reserved for future tiers (verified CC-BY 4.0, incompetech):
//   Waiting Room (tier 5): "Local Forecast - Elevator" — literal hold music.

import type { MusicTrackDef } from '../engine/music'

export const MUSIC_TRACKS: Record<'shallow' | 'deep', MusicTrackDef> = {
  shallow: { file: 'airport-lounge.mp3' },
  deep: { file: 'i-knew-a-guy.mp3' },
}
